/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1PodAffinityTerm,
    V1PodAffinityTermFromJSON,
    V1PodAffinityTermFromJSONTyped,
    V1PodAffinityTermToJSON,
} from './V1PodAffinityTerm';

/**
 * The weights of all of the matched WeightedPodAffinityTerm fields are added per-node to find the most preferred node(s)
 * @export
 * @interface V1WeightedPodAffinityTerm
 */
export interface V1WeightedPodAffinityTerm {
    /**
     * 
     * @type {V1PodAffinityTerm}
     * @memberof V1WeightedPodAffinityTerm
     */
    podAffinityTerm?: V1PodAffinityTerm;
    /**
     * weight associated with matching the corresponding podAffinityTerm,
     * in the range 1-100.
     * @type {number}
     * @memberof V1WeightedPodAffinityTerm
     */
    weight?: number;
}

export function V1WeightedPodAffinityTermFromJSON(json: any): V1WeightedPodAffinityTerm {
    return V1WeightedPodAffinityTermFromJSONTyped(json, false);
}

export function V1WeightedPodAffinityTermFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1WeightedPodAffinityTerm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'podAffinityTerm': !exists(json, 'podAffinityTerm') ? undefined : V1PodAffinityTermFromJSON(json['podAffinityTerm']),
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
    };
}

export function V1WeightedPodAffinityTermToJSON(value?: V1WeightedPodAffinityTerm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'podAffinityTerm': V1PodAffinityTermToJSON(value.podAffinityTerm),
        'weight': value.weight,
    };
}

